// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let InformationMessage = function (fieldSet)
{
    this.Code = Message.CODE_INFORMATION_MESSAGE;
    PFixMessage.call(this, fieldSet);
}
InformationMessage.prototype = Object.create(PFixMessage.prototype);

InformationMessage.prototype.setMsgType = function (msgtype)
{
    this.setFieldValue(FieldsFactory.FIELD_INFO_MSG_TYPE, msgtype);
}

InformationMessage.prototype.setMsgTypeId = function (msgtype)
{
    this.setFieldValue(FieldsFactory.FIELD_INFO_MSG_TYPE_ID, msgtype);
}

InformationMessage.prototype.setContent = function (content)
{
    this.setFieldValue(FieldsFactory.FIELD_CONTENT, content);
}

InformationMessage.prototype.setTimeSpan = function (timespan)
{
    this.setFieldValue(FieldsFactory.FIELD_TIMESTAMP, timespan);
}